<div class="banner-wrapper flex flex-row lt-md:flex-col gap-[24px] justify-start items-start">
  <div class="image flex-[305px] max-w-[305px] lt-md:flex-auto">
    <img src="/assets/img/learning-room-logo.png" />
  </div>
  <div
    class="content flex flex-col gap-[16px] justify-start items-start flex-[calc(100% - 305px - 24px)] max-w-[calc(100% - 305px - 24px)]"
  >
    <h2>{{ 'LEARNING_ROOM.TITLE' | translate }}</h2>
    <vi-text>{{ 'LEARNING_ROOM.DESCRIPTION' | translate }}</vi-text>
    <div class="button-wrapper">
      <a
        href="https://learningspace.viessmann-climatesolutions.com/"
        gtm="onOpen"
        gtmAction="Learning Space page"
        gtmCategory="installationsOverview"
        target="_blank"
      >
        <button mat-raised-button color="primary">
          {{ 'LEARNING_ROOM.BUTTON.REDIRECT_TO_LEARNINGSPACE' | translate }}
        </button>
      </a>
    </div>
  </div>
  <button
    class="close-button"
    mat-icon-button
    gtm="onClose"
    gtmCategory="learningSpaceBanner"
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
